module.exports = __webpack_public_path__ + "img/bot_event_info_day2.cb9374c5.png";